$('.featured-case-study--link').on('click',function(e) {

  e.preventDefault();
  $( $(this).attr('href') ).addClass('is-open');

});

$('.case-study-modal-close').on('click',function(e) {

  e.preventDefault();
  $( $(this).attr('href') ).removeClass('is-open');

});

